// スクロール後のヘッダー（header-compact.css 参照・2026-10-23）。ヘッダー（スマホはアイコン5つの段まで）を通り過ぎたら html に .hc-on、
// 下に送っている間は .hc-down を付ける。ヘッダーが固定に切り替わって抜けた高さは .hc-spacer で埋め、ページが跳ねないようにする
(function () {
  var root = document.documentElement, sec = document.querySelector('.shopify-section-header');
  if (!sec) return;
  var spacer = document.createElement('div');
  spacer.className = 'hc-spacer';
  sec.parentNode.insertBefore(spacer, sec.nextSibling);
  var limit = 0, lastY = window.scrollY;
  function measure() {
    if (root.classList.contains('hc-on')) return;
    var menu = document.querySelector('.mobile-menu');
    var menuBottom = menu && menu.offsetHeight ? menu.getBoundingClientRect().bottom + window.scrollY : 0;
    limit = Math.max(sec.getBoundingClientRect().bottom + window.scrollY, menuBottom);
    spacer.style.height = sec.offsetHeight + 'px';
  }
  function onScroll() {
    var y = window.scrollY, on = y > limit;
    root.classList.toggle('hc-on', on);
    if (!on) root.classList.remove('hc-down');
    else if (y > lastY + 4) root.classList.add('hc-down');
    else if (y < lastY - 4) root.classList.remove('hc-down');
    lastY = y;
  }
  measure();
  window.addEventListener('resize', function () { measure(); onScroll(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
